<template>
    <div class="items-block" :style="`--slides: ${swiperOptions.slidesPerView}`">
        <div class="flex-c items-block__header">
            <nuxt-link
                class="index-block__title text_15 text_bold"
                :class="block.color_class"
                v-if="block.link"
                :to="block.link"
                >{{ block.name }}</nuxt-link
            >
            <div class="index-block__title text_15 text_bold" v-else>
                {{ block.name }}
            </div>
            <nuxt-link v-if="block.linkToAll" :to="block.link" class="text_11 items-block__to-all">{{
                $t("view_all")
            }}</nuxt-link>
        </div>
        <div v-if="block.items" class="index-block__content">
            <swiper :options="swiperOptions" v-if="$device.isDesktop">
                <swiper-slide v-for="(item, i_index) in block.items" :key="`${i_index}-c`" :index="i_index + 1">
                    <Product :data="item" is-for-slider :is-manual-lazy-image="true" />
                </swiper-slide>

                <template v-if="block.items.length > 4">
                    <div slot="button-prev" class="splide__arrow splide__arrow--prev"></div>
                    <div slot="button-next" class="splide__arrow splide__arrow--next"></div>
                </template>
            </swiper>
            <div class="index-block__native-slider" v-else>
                <div
                    class="index-block__native-slider-item"
                    v-for="(item, i_index) in block.items"
                    :key="`hand-${i_index}`"
                    :index="i_index + 1">
                    <Product :data="item" is-for-slider :is-manual-lazy-image="true" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "@/plugins/swiper.client";
import Product from "@/components/Product";

export default {
    name: "ProductBlockSlider",
    components: { Product, Swiper, SwiperSlide },
    props: {
        block: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            swiperOptions: {
                spaceBetween: 1,
                slidesPerView: this.$device.isMobile ? 2 : 4,
                navigation: {
                    nextEl: ".splide__arrow--next",
                    prevEl: ".splide__arrow--prev",
                },
                keyboard: { enabled: true, onlyInViewport: false },
                mousewheel: {
                    forceToAxis: true,
                },
                freeMode: true,
            },
        };
    },
    computed: {
        cropSize() {
            return {
                desktop: { width: 630, height: 950 },
                mobile: { width: 216, height: 324 },
            };
        },
    },
};
</script>
<style scoped lang="less">
.items-block {
    &__header {
        padding: 32px;
        justify-content: space-between;
        gap: 16px;
        @media @sm {
            padding: 24px 16px;
        }
    }
    &__to-all {
        text-decoration: underline;
    }

    a {
        height: 100%;
        display: block;
        img {
            height: 100%;
            object-fit: cover;
            width: 100%;
            display: block;
        }
    }
}

::v-deep .splide {
    &__pagination {
        bottom: 100%;
        right: 0;
        width: auto;
        transform: none;
        justify-content: flex-end;
        padding: 0 16px;
        margin-bottom: 19px;
        &__page {
            width: 6px;
            height: 6px;
            background: @border2;
            border-radius: 0;
            margin: 0 5px;
            transform: rotate(45deg);
            opacity: 1;
            &.is-active {
                transform: rotate(45deg);
                background: #000;
            }
        }
    }
}

.swiper-slide {
    height: auto;
}
</style>
